import { Component, OnInit } from '@angular/core';
import { Quotation } from '../quotation';
import { Requirement } from '../requirement';
import { QuotationService } from '../quotation.service';
import { VendorService } from '../../vendor/vendor.service';

import { ActivatedRoute, Params } from '@angular/router';
import { Router} from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../auth.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Location } from '@angular/common';
import { ToastrManager } from 'ng6-toastr-notifications';
import { UtilityService } from  '../../utility.service';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { SlideInOutAnimation } from '../../animations';
import {  FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { routerNgProbeToken } from '@angular/router/src/router_module';
import { environment } from '../../environments/environment';
const baseUrl = environment.baseUrl;
const URL = baseUrl+'/api/upload';

@Component({
  selector: 'app-quotation-details',
  templateUrl: './quotation-details.component.html',
  styleUrls: ['./quotation-details.component.css'],
  animations: [SlideInOutAnimation]
})
export class QuotationDetailsComponent implements OnInit {

  public uploader: FileUploader;
	authHeader: Array<Headers> = [];
	authToken = '';

  closeResult: string;
  page=1;
  currentPage = 1;
  itemsPerPage = 5;
  pageSize: number;
  quotation = new Quotation(); 
  quotationlist: Quotation[];
  requirement = new Requirement();
  animationState = 'in';
  quotationFilter: any = { vendorname: '' };
  totalrecord:number;
  quotationpath: string;
  
  submitted = false;
	vendors: any[];
  quotations: any [];
  
    private newAttribute: any = {};
    quotationlistForm: FormGroup;
    public isupdate = false;
    public FormName = "Add New Quotation List";

  constructor(
    private quotationService: QuotationService,
    private route: ActivatedRoute,
    private spinnerService: Ng4LoadingSpinnerService,
    private location: Location,
    private util:UtilityService, 
    public toastr: ToastrManager,
    private modalService: NgbModal,
    private vendorService : VendorService,
    private formBuilder: FormBuilder,
    private router: Router,
    public auth: AuthService
  ) { }

  open(content,requirementid) {
      this.getVendors(); 
    this.modalService.open(content,  {ariaLabelledBy: 'modal-basic-title',centered: true, size: 'sm' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }



  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.quotationlistForm.invalid) {
        return this.util.showError("Please enter required fields.");		
    }
  else{
    if(this.isupdate){
      this.update();
    }
    else{
      this.addQuotation();
    }
  }
}

addQuotation() {
    //this.submitted = true;
    this.save();
  }

 
private save(): void {	  


 this.quotation.createdby = this.auth.currentUserValue.userid
 this.quotation.requirementid = this.requirement.requirementid;
 
  this.quotationService.addQuotation(this.quotation).subscribe((data :any) => {
	  

	this.GetQuotationDetails(this.requirement.requirementid);
	this.GetRequirementDetails(this.requirement.requirementid);
    this.util.showSuccess("Quotation List added successfully.")
    this.router.navigate(['/quotation-list']);
  });
  //this.router.navigate(['/department-list']);
        //for Redirecting to the list view     
}
goBack(): void {
  this.location.back();
}

update(): void {
  this.submitted = true;
  this.quotationService.updateQuotation(this.quotation)
      .subscribe(() => 

	  {
		this.util.showSuccess("Quotation update successfully.");
      //this.router.navigate(['/department-list']);
	  	this.GetQuotationDetails(this.requirement.requirementid);
		this.GetRequirementDetails(this.requirement.requirementid);
	  });
}

ngOnInit() {


  // this.getrequester();
  if(this.route.snapshot.paramMap.get('requirementid') != null)
  {
    const requirementid = +this.route.snapshot.paramMap.get('requirementid');
     if(requirementid > 0)
     {
       this.GetRequirementDetails(requirementid);
	   this.GetQuotationDetails(requirementid);
     }
    // this.isupdate = true;
     //this.FormName = "Update Quotation";				 
  }
  this.quotationlistForm = this.formBuilder.group({			
    vendorid: [this.quotation.vendorid,[Validators.required, Validators.required]],
    amount: [this.quotation.amount,[Validators.required, Validators.required]]
  });	

  //quotation upload code starts below 
  this.authToken = 'Bearer ' + this.auth.currentUserValue.token;
		
  this.uploader = new FileUploader({url: URL, authTokenHeader : 'Authorization',authToken: this.authToken ,itemAlias: 'photo'});
  this.uploader.onAfterAddingFile = (file)=> { file.withCredentials = false; };
   //overide the onCompleteItem property of the uploader so we are 
   //able to deal with the server response.
   this.uploader.onCompleteItem = (item:any, response:any, status:any, headers:any) => {
     
        var response = JSON.parse(response);
        var data = {};
  ;
    if(response.error_code==0){
    
      if(response.data.length > 0)
      {
        this.quotation.quotationpath = "uploads/" + response.data; 
      }
  }
}
//quotation upload code ends here

}
  GetRequirementDetails(requirementid) {    
     this.quotationService.GetRequirementDetails(requirementid)
       .subscribe(requirement => this.requirement = requirement[0]);
   }
    GetQuotationDetails(requirementid) {    
     this.quotationService.GetQuotationDetails(requirementid)
       .subscribe(quotation => {
		   
		   
				   if (!Array.isArray(quotation)) {
	                    this.quotationlist.push(quotation);

	                }
	                else {
	                    this.quotationlist = quotation;
                  }
                  this.totalrecord = this.quotationlist.length;
	   });
   }
// convenience getter for easy access to form fields
get f() {
return this.quotationlistForm.controls
}


//   getrequester() {
//   return this.quotationService.getrequester()
//              .subscribe(
//               requester => {                  
//                 this.requester = requester				  
//                }
//               );
// }

getVendors() {
  return this.vendorService.getvendorlistByRequirement(this.requirement.requirementid)
             .subscribe(
              vendors => {
         
                //this.vendors = vendors
				 if (!Array.isArray(vendors)) {
	                    this.vendors.push(vendors);

	                }
	                else {
	                    this.vendors = vendors;
	                }
        
               }
              );
}


getQuotation(quotationid) {
return this.quotationService.getQuotation(quotationid)
           .subscribe(
            quotation => {              
              this.quotation = quotation              
             }
            );
}

  //below function is to restrict special character in input field
  omit_special_char(e) {
  var k;
  document.all ? k = e.keyCode : k = e.which;
  return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }


  toggleShowDiv(divName: string) {
    if (divName === 'moredetails') {
      this.animationState = this.animationState === 'out' ? 'in' : 'out';
    }
  }

  acceptQuote(quotationid){

    this.quotation = this.quotationlist.filter(item=> item.quotationid ==quotationid)[0];
    this.quotation.approvedstatus = 1;
    this.quotationService.updateQuotation(this.quotation)
      .subscribe(() =>
	  {
      //this.router.navigate(['/department-list']);
  
			this.requirement.status = 1;
			this.quotationService.updateRequirement(this.requirement)
			  .subscribe(() =>
			  {	  this.util.showSuccess("Quotation approved successfully.");

				this.GetQuotationDetails(this.requirement.requirementid);
				this.GetRequirementDetails(this.requirement.requirementid);
			  });
	  });


  }

  
  public onPageChange(pageNum: number): void {
    this.pageSize = this.itemsPerPage*(pageNum - 1);
  }
  
  public changePagesize(num: number): void {
  this.itemsPerPage = this.pageSize + num;
  }
  
}
